import { Button, Card, Stack, TextField, Typography } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"

export function AuthBundleHeader({
    bundleName,
    demandCount,
    scheduleTypeCount,
    featureCount,
    totalDemands,
    onNameChange,
    onExport,
    onImport,
}) {
    return (
        <Card sx={{ p: 2.5, mb: 2 }}>
            <Stack direction={{ xs: "column", sm: "row" }} spacing={2} alignItems={{ xs: "stretch", sm: "flex-start" }}>
                <Stack
                    alignItems="center"
                    justifyContent="center"
                    sx={{
                        width: 46,
                        height: 46,
                        borderRadius: 1.5,
                        bgcolor: "primary.lighter",
                        color: "primary.darker",
                        flexShrink: 0,
                    }}
                >
                    <Iconify icon="mdi:package-variant-closed" width={26} />
                </Stack>
                <Stack spacing={1.5} sx={{ flex: 1, minWidth: 0 }}>
                    <TextField
                        value={bundleName}
                        onChange={onNameChange}
                        label="Bundle name"
                        size="small"
                        inputProps={{ "data-cy": "auth-bundle-name-input" }}
                    />
                    <Typography variant="body2" color="text.secondary">
                        A reusable set of demands granted together. Apply it to users, roles or clients from their
                        records.
                    </Typography>
                    <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
                        <Typography variant="caption" sx={chipSx}>
                            {demandCount} permissions
                        </Typography>
                        <Typography variant="caption" sx={chipSx}>
                            {scheduleTypeCount} schedule types
                        </Typography>
                        <Typography variant="caption" sx={chipSx}>
                            {featureCount} feature flags
                        </Typography>
                        <Typography variant="caption" sx={chipSx}>
                            {totalDemands} total demands
                        </Typography>
                    </Stack>
                </Stack>
                <Stack direction="row" spacing={1}>
                    <Button
                        variant="outlined"
                        size="small"
                        startIcon={<Iconify icon="eva:download-outline" />}
                        onClick={onExport}
                    >
                        Export
                    </Button>
                    <Button
                        variant="contained"
                        size="small"
                        startIcon={<Iconify icon="eva:upload-outline" />}
                        onClick={onImport}
                    >
                        Import pack
                    </Button>
                </Stack>
            </Stack>
        </Card>
    )
}

const chipSx = {
    bgcolor: "background.neutral",
    color: "text.secondary",
    borderRadius: 0.75,
    px: 1,
    py: 0.5,
    fontWeight: 600,
}
